import {ATLAS_DB, REALTIME_DB} from '@/config/firebase';
import {ref} from 'firebase/database';

export const allRadarRef = () => {
  return ref(REALTIME_DB, `${ATLAS_DB}/radar`);
};

export const allAirlinesWhitelistRef = () => {
  return ref(REALTIME_DB, 'airlines_whitelist');
};
